import React from 'react';
import { Box, Typography, Button, Modal, CircularProgress } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { tokens } from '../../Common/designTokens'; // added

const OrderSuccessModal = ({ 
  open, 
  onClose, 
  success,
  errorMessage,
  orderCount 
}) => {
  // Check if error is related to inactive account
  const isAccountError = errorMessage && errorMessage.toLowerCase().includes('not active');
  
  const handleClose = () => {
    onClose();
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: tokens.colors.bodyBackgroundColor,
    border: success ? `1px solid ${tokens.palette.primaryA25 || tokens.palette.primary}` : `1px solid ${tokens.palette.danger}`,
    boxShadow: success ? `0 0 10px ${tokens.palette.primaryA04}` : `0 0 10px ${tokens.palette.danger}`,
    borderRadius: "8px",
  };

  return (
    <Modal
      open={open}
      onClose={success || isAccountError ? handleClose : undefined} // Only allow backdrop close for success or account errors
      aria-labelledby="order-success-modal"
    >
      <Box sx={modalStyle}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            width: "100%",
            py: 6,
          }}
        >
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              border: success ? `2px solid ${tokens.palette.primary}` : `2px solid ${tokens.palette.danger}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
            }}
          >
            {success ? (
              <CheckIcon sx={{ fontSize: 32, color: tokens.palette.primary }} />
            ) : (
              <Typography variant="h5" sx={{ color: tokens.palette.danger }}>!</Typography>
            )}
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "500", color: tokens.colors.fontColour, textAlign: "center" }}>
            {success 
              ? orderCount > 1 
                ? `${orderCount.toLocaleString()} Orders Successfully Placed`
                : "Order Successfully Placed"
              : "Failed to Place Orders"
            }
          </Typography>
          
          {!success && (
            <Typography 
              sx={{ 
                color: tokens.palette.danger,
                mt: 2, 
                textAlign: "center",
                maxWidth: "320px",
                px: 2
              }}
            >
              {errorMessage === "Something went wrong."
                ? "Something went wrong."
                : errorMessage || "An error occurred during order placement."}
            </Typography>
          )}
        </Box>
        <Box sx={{ width: "100%", height: 1, backgroundColor: tokens.colors.bodyBorderColor50 }} />
        <Box
          sx={{
            width: "100%",
            p: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{
              backgroundColor: success ? tokens.palette.primary : tokens.palette.danger,
              color: tokens.colors.white,
               textTransform: "none",
              borderRadius: "8px",
               width: 150,
               fontWeight: 700,
               py: 1,
               "&:hover": { 
                backgroundColor: success ? tokens.palette.primaryA80 : tokens.palette.danger
               },
             }}
           >
             {success || isAccountError ? 'Close' : 'Try Again'}
           </Button>
         </Box>
       </Box>
     </Modal>
   );
 };

 export default OrderSuccessModal;
